export const HOST_ADD_REVIEW = "ADD_REVIEW"
export const HOST_ADD_REVIEW_SUCCESSFUL = "ADD_REVIEW_SUCCESSFUL"
export const HOST_ADD_REVIEW_FAILED = "ADD_REVIEW_FAILED"
export const HOST_ADD_REVIEW_RESET = "ADD_REVIEW_RESET"

